import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import NorthStar from "./NorthStar";

export default function Philosophy() {
  return (
    <section id="philosophy" className="relative overflow-hidden border-t border-charcoal py-20 sm:py-40" data-testid="philosophy">
      <div className="pointer-events-none absolute -right-16 top-1/2 -translate-y-1/2 opacity-[0.9]">
        <motion.div
          animate={{ scale: [1, 1.05, 1], opacity: [0.5, 0.8, 0.5] }}
          transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
        >
          <NorthStar className="w-[280px] sm:w-[520px] text-charcoal star-glow" />
        </motion.div>
      </div>

      <div className="relative z-10 mx-auto max-w-[1600px] px-6 sm:px-10">
        <Reveal>
          <div className="label mb-8">NSTR Philosophy</div>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-sans font-semibold uppercase text-warm text-[2.7rem] sm:text-8xl lg:text-[9rem] leading-[0.9] sm:leading-[0.85] tracking-[-0.03em] max-w-5xl">
            More than followers.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-10 max-w-2xl text-silver text-lg sm:text-2xl leading-relaxed font-light">
            We represent personalities with the ability to move culture. NSTR combines talent
            management, brand partnerships and digital strategy to build careers that extend far
            beyond the feed.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
